import ColoredLogo from "./ColoredLogo";

export default ColoredLogo;
